import { render, staticRenderFns } from "./OrdinaryStore.vue?vue&type=template&id=cc7d66c8&scoped=true&"
import script from "./OrdinaryStore.vue?vue&type=script&lang=js&"
export * from "./OrdinaryStore.vue?vue&type=script&lang=js&"
import style0 from "./OrdinaryStore.vue?vue&type=style&index=0&id=cc7d66c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7d66c8",
  null
  
)

export default component.exports